import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconFaceExtraHappy20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconFaceExtraHappy20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M17.5 10a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0m1.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0M7.075 9.1a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25m6.975-1.125a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0M10 14.083c-1.139 0-2.245-.564-3.063-1.583h6.126c-.818 1.019-1.924 1.583-3.063 1.583m0 1.5c2.123 0 3.982-1.337 5.001-3.337.305-.597-.175-1.246-.845-1.246H5.844c-.67 0-1.15.65-.845 1.246 1.02 2 2.878 3.337 5.001 3.337"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconFaceExtraHappy20);
